import { createMutation } from "@tanstack/solid-query";
import { Show, createSignal } from "solid-js";
import { uploadAvatar } from "~/lib/api";
import { Avatar } from "~/components/Avatar";

type Props = {
  eventId?: string;
  displayName?: string | null;
  avatarUrl?: string | null;
  onUploaded?: (url: string) => void;
};

export function AvatarUpload(props: Props) {
  const [preview, setPreview] = createSignal<string | null>(null);
  const [localError, setLocalError] = createSignal("");

  const mutation = createMutation(() => ({
    mutationFn: (file: File) => uploadAvatar(file, props.eventId),
    onSuccess: (res) => {
      setLocalError("");
      const url = res.data?.avatar_url ?? null;
      if (url) {
        setPreview(url);
        props.onUploaded?.(url);
      }
    },
    onError: (err: unknown) => {
      setLocalError((err as Error).message);
    },
  }));

  function onFileChange(e: Event) {
    const input = e.currentTarget as HTMLInputElement;
    const file = input.files?.[0];
    if (!file) return;
    setLocalError("");
    mutation.mutate(file);
    input.value = "";
  }

  const shownUrl = () => preview() ?? props.avatarUrl;

  return (
    <div class="avatar-upload">
      <Avatar url={shownUrl()} name={props.displayName} size="lg" />
      <label class="btn btn-ghost avatar-upload-btn">
        {mutation.isPending ? "Uploading…" : "Upload photo"}
        <input type="file" accept="image/jpeg,image/png" onChange={onFileChange} hidden />
      </label>
      <Show when={localError() || mutation.isError}>
        <p class="muted" style={{ color: "#ff8a9b" }}>
          {localError() || (mutation.error as Error)?.message}
        </p>
      </Show>
    </div>
  );
}